// コミュニケーション手段のエンティティ
export class Communicate {
  // ユーザーID DB型(*fk)
  public user_id?: string;
  // 聴力タイプ DB型(*varchar20)
  public hearing_type?: string;
  // 日本手話レベル DB型(*varchar20)
  public sign_language?: string;
  // 日本語対応手話レベル DB型(*varchar20)
  public corresponding_sign_language?: string;
  // 発音レベル DB型(*varchar20)
  public pronunciation?: string;
  // 日本語読み書きレベル DB型(*varchar20)
  public read_write_level?: string;
  // アクタータイプ DB型(*varchar64)
  public actor_type?: string;
  static fromDB(record: { [column: string]: any; [column: number]: any }): Communicate {
    const entity = new Communicate();
    entity.user_id = record['user_id'];
    entity.hearing_type = record['hearing_type'];
    entity.sign_language = record['sign_language'];
    entity.corresponding_sign_language = record['corresponding_sign_language'];
    entity.pronunciation = record['pronunciation'];
    entity.read_write_level = record['read_write_level'];
    entity.actor_type = record['actor_type'];
    return entity;
  }
  static getTypeFitEntity(value: any): Communicate {
    const entity = new Communicate();
    entity.user_id = value.user_id;
    entity.hearing_type = value.hearing_type;
    entity.sign_language = value.sign_language;
    entity.corresponding_sign_language = value.corresponding_sign_language;
    entity.pronunciation = value.pronunciation;
    entity.read_write_level = value.read_write_level;
    entity.actor_type = value.actor_type;
    return entity;
  }
}
